import React from 'react';
import { Button } from '../ui/Shared';
export const Navbar = () => <nav className="sticky top-0 z-40 bg-negro/95 backdrop-blur-sm border-b border-gris-medio px-5 py-3.5 flex items-center justify-between" data-id="element-16">
    <span className="text-[13px] font-bold tracking-widest text-cyan uppercase" data-id="element-17">
      Infodigital Core
    </span>
    <Button variant="nav" href="#ofertas" data-id="element-18">
      Quiero el kit
    </Button>
  </nav>;
export const Footer = () => <footer className="border-t border-gris-oscuro py-10 px-5 text-center text-[13px] text-gris-claro" data-id="element-19">
    <p className="text-[15px] font-bold text-cyan mb-2" data-id="element-20">
      KIT ITALIANO PRO™ — INFODIGITAL CORE
    </p>
    <p className="max-w-md mx-auto" data-id="element-21">
      El sistema docente N°1 para profesores de italiano en Argentina.
      <br data-id="element-22" />
      Porque enseñar bien no debería costarte horas de preparación ni ingresos
      inestables.
    </p>
    <p className="mt-4" data-id="element-23">soporteIDC1@outlook.com · @infordigitalcore</p>
    <p className="mt-3 text-xs" data-id="element-24">
      © INFODIGITAL CORE™ 2025 — Todos los derechos reservados.
    </p>
  </footer>;